// PrivacyPolicy.tsx
import React from "react";
import './FooterLinks.css'

export default function TOS() {
  return (
    <div className="Main">
      <h1 className="">TERMS OF SERVICE</h1>
        <div>
        <h2 className="ItemTitle">Terms of Service for Viddy Studio Inc.</h2>
        <p></p>
      </div>
    <div className="Item">
        <h2 className="ItemTitle">Introduction:</h2>
        <p>These terms of service govern your use of the Viddy Studio Inc. website and software (the "Service"). By accessing or using the Service, you agree to be bound by these terms and conditions.</p>
      </div>
    <div className="Item">
        <h2 className="ItemTitle">Use of the Service:</h2>
        <p>The Service is intended for personal and commercial use. You may not use the Service for any illegal or unauthorized purpose. You must not, in the use of the Service, violate any laws in your jurisdiction.</p>
      </div>
    <div className="Item">
        <h2 className="ItemTitle">Intellectual Property:</h2>
        <p>The Service and its original content, features and functionality are owned by Viddy Studio Inc. and are protected by international copyright and trademark laws.</p>
      </div>
    <div className="Item">
        <h2 className="ItemTitle">Termination:</h2>
        <p>We may terminate or suspend your access to the Service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the terms of service.</p>
      </div>
    <div className="Item">
        <h2 className="ItemTitle">Disclaimer of Warranties:</h2>
        <p>The Service is provided "as is," without warranty of any kind, either express or implied, including, but not limited to, the implied warranties of merchantability, fitness for a particular purpose, or non-infringement.</p>
      </div>
    <div className="Item">
        <h2 className="ItemTitle">Limitation of Liability:</h2>
        <p>In no event shall Viddy Studio Inc. be liable to you for any direct, indirect, incidental, special, or consequential damages resulting from the use or inability to use the Service.</p>
      </div>
    <div className="Item">
        <h2 className="ItemTitle">Governing Law:</h2>
        <p>These terms of service are governed by and construed in accordance with the laws of the State of Utah, and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.</p>
      </div>
    </div>
  );
}
